// Libs
import React, { Component } from 'react'
import { NavLink } from 'react-router-dom'
import { Row, Col } from '../../../../components/Elemental'

// CSS
import './styles.scss'

class SearchList extends Component {
  render() {
    const { source: { id, lawsuit, system_code, client, lawyer, company, law_firm, status }, ...props } = this.props
    let to = `/meus-casos/${id}`

    return (
      <NavLink to={to} className={`search-list search-list--status-${status}`} {...props}>
        <Row className="search-list__row">
          <Col xs="10%">
            <p className="search-list__id">{id}</p>
          </Col>
          <Col xs="17%">
            <p>{lawsuit.number ? lawsuit.number : '-'}</p>
          </Col>
          <Col xs="13%">
            <p>{system_code ? system_code : '-'}</p>
          </Col>
          <Col xs="15%">
            <p>{client.name.toLowerCase()}</p>
          </Col>
          <Col xs="15%">
            <p>{lawyer.name.toLowerCase()}</p>
          </Col>
          <Col xs="15%">
            <p>{company.fantasy_name ? company.fantasy_name : company.name}</p>
          </Col>
          <Col xs="15%">
            <p>{law_firm.name ? law_firm.name : 'Departamento Jurídico'}</p>
          </Col>
        </Row>
      </NavLink>
    )
  }
}

export default SearchList
